
import Emercoin from "../../../assets/filled/Emercoin.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function EmercoinIcon({ className, dataTestid = "EmercoinIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Emercoin data-testid={dataTestid} className={classes} {...rest} />
  );
}
